export default __webpack_public_path__ + "static/media/yellow4en.c00b6832.jpg";